import { linkedAccountsQueryKeys as e } from "./useLinkedAccountsQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { usersApi as r } from "@maat/api-main";
import { authQueryKeys as i } from "@maat/store-auth";
//#region src/useUnlinkOAuthMutation.ts
var a = () => {
	let a = n();
	return t({
		mutationFn: (e) => r.unlinkOAuthAccount(e),
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.list() }), a.invalidateQueries({ queryKey: i.me() });
		}
	});
};
//#endregion
export { a as useUnlinkOAuthMutation };
